// extracted by mini-css-extract-plugin
export default {"encodedPage":"Encoded_encodedPage__y-vU6","encodedImg":"Encoded_encodedImg__jNWaE"};